import React from 'react';
import './ourTeam.css'
import {Container, Col, Row, Image} from 'react-bootstrap'
import {Swiper, SwiperSlide} from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/free-mode';
import 'swiper/css/pagination';
import {Autoplay, FreeMode} from "swiper/modules";
import SlideCard from "../accesories/card/SlideCard";
import PersonnelCard from "../accesories/card/PersonnelCard";

function OurTeam({header, span, teamMembers=[]}) {
    console.log(teamMembers)
    return (
        <Container className={'our-team-container'}>
            <Row className="our-team-up-row mb-4">
                <Col className={'text-center'}>
                    <h3>{header} <span>{span}</span></h3>
                    <div className={'horizontal-line'}/>
                </Col>
            </Row>
            <Swiper
                slidesPerView={1} // تعداد اسلاید پیش‌فرض
                spaceBetween={30} // فاصله بین اسلایدها
                freeMode={true} // اجازه حرکت آزادانه
                autoplay={{
                    delay: 1500, // زمان تاخیر بین هر تغییر اسلاید (۳ ثانیه)
                    disableOnInteraction: false,
                    pauseOnMouseEnter: true
                }}
                loop={true} // برای اجرای بی‌نهایت
                modules={[FreeMode, Autoplay]} // ماژول‌های مورد نیاز
                className="mySwiper"
                breakpoints={{
                    // برای صفحات با عرض بزرگتر از 992px (lg)
                    // 1200: {
                    //     slidesPerView: 4, // 4 اسلاید در حالت lg
                    // },
                    992: {
                        slidesPerView: 3, // 4 اسلاید در حالت lg
                    },
                    // برای صفحات با عرض بزرگتر از 768px (md)
                    768: {
                        slidesPerView: 2, // 3 اسلاید در حالت md
                    },
                    // برای صفحات با عرض کمتر از 768px (sm)
                    576: {
                        slidesPerView: 1, // 1 اسلاید در حالت sm
                    }
                }}
            >
                <Row className={'our-team-down-row'}>
                    {teamMembers.map((member, index)=>(
                        <SwiperSlide key={index}>
                            <PersonnelCard {...member}/>
                        </SwiperSlide>
                    ))}
                </Row>
            </Swiper>
        </Container>
    );
}

export default OurTeam;